import { MsalProvider } from '@azure/msal-react';
import { Layout } from '@organisms/Layout';
import { initGA, logPageView, msalInstance } from '@utils';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from 'react-router-dom';
import { useEffect } from 'react';
import {
  BeforeYouStartPage,
  CallUsPage,
  ReportTypePage,
  IssueTypePage,
  ConfirmationPage,
  ConfirmationEmailPage,
  ContactAboutTheIssuePage,
  DescribeTheIssuePage,
  IssueLocationPage,
  RecurringIssuePage,
  UploadPhotoPage,
  YourDetailsPage,
} from './components/pages';
import { RoutesList, steps } from './routes/Routes';
import { basename } from './routes/basename';
import { InternalServerErrorTemplate, NotFoundErrorTemplate } from '@templates';
import { scrollTop } from '@utils';

function App() {
  // It's important that the Router component is above the pages component because you'll need to use the useHistory hook before rendering MsalProvider
  useEffect(() => {
    initGA();
    logPageView();

    // Log page views on route change
    const logPageViewOnRouteChange = () => logPageView();
    window.addEventListener('popstate', logPageViewOnRouteChange);

    return () =>
      window.removeEventListener('popstate', logPageViewOnRouteChange);
  }, []);

  return (
    <Router basename={basename}>
      <RouteChangeTracker />
      <Pages />
    </Router>
  );
}

function Pages() {
  const location = useLocation();

  useEffect(() => {
    scrollTop();
  }, [location.pathname]);

  return (
    <MsalProvider instance={msalInstance}>
      <Layout steps={steps}>
        <Routes>
          <Route
            path={RoutesList.BEFORE_YOU_START}
            element={<BeforeYouStartPage />}
          />
          <Route path={RoutesList.CALL_US} element={<CallUsPage />} />
          <Route
            path={RoutesList.CONFIRMATION}
            element={<ConfirmationPage />}
          />
          <Route
            path={RoutesList.CONFIRMATION_EMAIL}
            element={<ConfirmationEmailPage />}
          />
          <Route
            path={RoutesList.CONTACT_ABOUT_THE_ISSUE}
            element={<ContactAboutTheIssuePage />}
          />
          <Route
            path={RoutesList.DESCRIBE_THE_ISSUE}
            element={<DescribeTheIssuePage />}
          />
          <Route path={RoutesList.ISSUE_TYPE} element={<IssueTypePage />} />
          <Route path={RoutesList.UPLOAD_PHOTO} element={<UploadPhotoPage />} />
          <Route
            path={RoutesList.ISSUE_LOCATION}
            element={<IssueLocationPage />}
          />
          <Route
            path={RoutesList.IS_RECURRING_ISSUE}
            element={<RecurringIssuePage />}
          />
          <Route path={RoutesList.REPORT_TYPE} element={<ReportTypePage />} />
          <Route path={RoutesList.YOUR_DETAILS} element={<YourDetailsPage />} />
          <Route
            path={RoutesList.INTERNAL_SERVER_ERROR}
            element={<InternalServerErrorTemplate />}
          />
          <Route
            path={RoutesList.NOT_FOUND}
            element={<NotFoundErrorTemplate />}
          />
        </Routes>
      </Layout>
    </MsalProvider>
  );
}

// Component to track route changes and log page views
export const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return null;
};


export default App;
